import { Kbd } from "@components/Kbd";
import {
  generalShortcutRows,
  goToShortcutRows,
  type ShortcutRow,
  type ShortcutSurface,
} from "@components/keyboardShortcuts";
import { useUser } from "@context/UserContext";
import { Dialog } from "@scribenote/brian-design-system";
import { canAccessAdmin } from "@users/userClient";

const ShortcutGroup = ({
  title,
  rows,
}: {
  title: string;
  rows: ShortcutRow[];
}) => (
  <div className="flex flex-col">
    <h3 className="mb-1 text-annotation-caps text-annotation">{title}</h3>
    <div className="divide-y divide-rule">
      {rows.map((row) => (
        <div
          key={row.label}
          className="flex items-center justify-between gap-3 py-2"
        >
          <span className="min-w-0 truncate text-sm text-ink-body">
            {row.label}
          </span>
          <Kbd tokens={row.tokens} />
        </div>
      ))}
    </div>
  </div>
);

export const KeyboardShortcutsModal = ({
  surface,
  isOpen,
  onClose,
}: {
  surface: ShortcutSurface;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { currentUser } = useUser();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      size="md"
      // Dropped while closed: a native <dialog> stays mounted, so an
      // unconditional testid would report an open dialog that isn't there.
      data-testid={isOpen ? "keyboard-shortcuts-modal" : undefined}
      title="Keyboard shortcuts"
    >
      <div className="flex flex-col gap-6">
        <ShortcutGroup title="General" rows={generalShortcutRows()} />
        <ShortcutGroup
          title="Go to"
          rows={goToShortcutRows(surface, canAccessAdmin(currentUser))}
        />
      </div>
    </Dialog>
  );
};
